import React from 'react';
import { Link } from 'react-router-dom';

// Styles
import styles from "./../StaffManagment.module.css";

// Images
import arrowBlue from "./../../../../assets/img/DashboardICons/ArrowLeftBlue.svg";

const StaffActivityCardLocateFileTable = (props) => {

    return (
        <>
            <div
                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-2 mx-2"
                dir="rtl"
            >
                <div className="mt-1 w-100" style={{ textAlign: "center" }}>
                    {props.children}
                    {
                        props.staffActivityCardTable.map((data, index) => (
                            <div key={data.id} className={`d-flex align-items-center justify-content-between flex-wrap my-3 p-3 ${styles.table_tr_tbody}`}>
                                <div className={`text-center col-3 ${styles.table_th}`}>
                                    {data.title}
                                </div>
                                <div className={`text-center col-3 ${styles.table_th}`}>
                                    {data.createDate.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                </div>
                                <div className={`text-center col-3 ${styles.table_th}`}>
                                    {data.createDate.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])}
                                </div>
                                <div className={`text-center col-3 pe-5 ${styles.table_th}`}>
                                    <Link to={{
                                        pathname: `/card-detail/${data.id}`,
                                        state: {
                                            state: data,
                                            isArchive: false
                                        }
                                    }}>
                                        <img src={arrowBlue} alt="arrow-left-blue" width="14" />
                                    </Link>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </>
    );
};

export default StaffActivityCardLocateFileTable;